// extracted by mini-css-extract-plugin
export default {"hexagon":"SkillCard_hexagon__T1F0K"};